// Thin wrappers around /api/onboarding for the OnboardingTour component.
import { get, post } from '../index';

export const getOnboardingStatus  = () => get('/api/onboarding/status');
export const dismissOnboarding    = () => post('/api/onboarding/dismiss', {});
export const completeOnboarding   = () => post('/api/onboarding/complete', {});
export const setOnboardingStep    = (stepIndex) => post('/api/onboarding/step', { stepIndex });
export const resetOnboarding      = () => post('/api/onboarding/reset', {});
